import { createAction } from '@reduxjs/toolkit';

import { ToastNotificationActions } from '../actionTypes';

export const setToastType = createAction<string>(
  ToastNotificationActions.SET_TOAST_NOTIFICATION,
);
